<template>
  <div class="writting-box">
    <v-textarea
      light
      counter=""
      single-line
      rows="3"
      row-height="25"
      no-resize
      class="px-4 py-4"
      max-length="450"
      v-model="content"
      :rules="[
        v =>
          (v || '').length <= 450 || 'The message can be 450 characters or less'
      ]"
      label="Enter your message here.."
      outlined
    >
      <v-progress-circular
        slot="append-outer"
        v-if="loadingMessage"
        :value="100"
        color="blue"
        indeterminate
      ></v-progress-circular>

      <v-icon
        v-else
        color="blue"
        x-large
        slot="append-outer"
        @click="sendMessage"
      >
        mdi-send
      </v-icon>
    </v-textarea>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "WritingBox",
  data() {
    return {
      content: "",
      loadingMessage: false
    };
  },
  computed: {
    ...mapState("inspections", ["inspectionProfile"])
  },
  methods: {
    async sendMessage() {
      const { $dialog, $store, inspectionProfile, content } = this;
      this.loadingMessage = true;
      try {
        let { id } = inspectionProfile;

        // Validando si menssages existe y tiene mas de 1 mensaje
        if (!inspectionProfile.messages) {
          inspectionProfile.messages = [];
        }
        // Agregando al array de message el nuevo mensaje
        inspectionProfile.messages.push({
          author: $store?.state?.auth?.user,
          createdDate: new Date(),
          content: content
        });
        this.content = "";
        // Actualizando el perfil de la inspeccion
        $store.dispatch("updateDocument", {
          data: { messages: inspectionProfile.messages },
          doc: id,
          db: "inspections"
        });
      } catch (error) {
        console.error(error);

        $dialog.notify.error(
          "Error sending a message, please contact support",
          {
            position: "bottom-right",
            timeout: 5000
          }
        );
      } finally {
        this.loadingMessage = false;
      }
    }
  }
};
</script>

<style scoped>
.writting-box {
  background-color: #fdfeff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: auto;
}
</style>
